import { Subproduct } from '@/redux/order/order-slice'

export const isNonReturnableProduct = (prod: Subproduct): boolean => {
  const product = prod.product

  return (
    (product.non_returnable_items && product.non_returnable_items.length > 0) ??
    false
  )
}
